import React from 'react';

const Footer = ({ setActiveTab }) => {
    return (
        <footer className="footer">
            <div className="container">
                <div className="footer-grid">
                    <div className="footer-section">
                        <h3>СФЕРА АВТО</h3>
                        <p>Более 2-х лет на автомобильном рынке.</p>
                    </div>
                    <div className="footer-section">
                        <h3>Навигация</h3>
                        <ul className="footer-nav">
                            <li><button onClick={() => setActiveTab('home')}>Главная</button></li>
                            <li><button onClick={() => setActiveTab('catalog')}>Каталог</button></li>
                            <li><button onClick={() => setActiveTab('services')}>Услуги</button></li>
                            <li><button onClick={() => setActiveTab('about')}>О нас</button></li>
                        </ul>
                    </div>
                    <div className="footer-section">
                        <h3>Контакты</h3>
                        <ul className="contact-list">
                            <li></li>
                            <li>Email: contact.sfera.avto@gmail.com</li>
                            <li>152909, Ярославская область, г Рыбинск Новолосевская ул, д. 4а  </li>
                        </ul>
                    </div>
                    <div className="footer-section">
                        <h3>Связь с Консультантом</h3>
                        <div className="social-icons">
                            <a
                                href="https://t.me/svetlana1986_1"
                                className="social-icon"
                                target="_blank"
                                rel="noopener noreferrer"
                            >TG</a>
                            <a
                                href="https://t.me/Ivan_avto_ru"
                                className="social-icon"
                                target="_blank"
                                rel="noopener noreferrer"
                            >TG</a>
                        </div>
                    </div>
                </div>
                <div className="copyright">
                    <p>© 2025 СФЕРА АВТО. Все права защищены.</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
